import { ISubscription, ISubscriptionPlan } from '@/types/subscription'
import { ApiService, RequestOptions } from './api'

export interface ISubscriptionPayload {
  subscriptionPlanType: string
}

export type ISubscriptionCreated = Omit<ISubscription, 'subscriptionPlan'> & {
  subscriptionPlanType: string
}

export interface ISubscriptionCreatedResponse {
  data: ISubscriptionCreated
}

export interface ISubscriptionPlanResponse {
  data: ISubscriptionPlan
}

export class SubscriptionService {
  static readonly path = '/subscriptions'
  static readonly plansSubPath = '/plans'
  static readonly httpClient = new ApiService()

  static async createSubscription(
    payload: ISubscriptionPayload,
    options?: RequestOptions
  ): Promise<ISubscriptionCreatedResponse> {
    return await SubscriptionService.httpClient.post(
      SubscriptionService.path,
      payload,
      options
    )
  }

  static async getSubscriptionPlan(
    id: string,
    options?: RequestOptions
  ): Promise<ISubscriptionPlanResponse> {
    const url = `${SubscriptionService.path}/${SubscriptionService.plansSubPath}/${id}`
    return await SubscriptionService.httpClient.get(url, options)
  }
}
